export default __webpack_public_path__ + "static/media/Banner - Hybridshell - Pink.64fb02b7.jpg";